import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';

import { ChipComponent } from '@shared/chip/chip.component';
import { TooltipComponent } from '@shared/tooltip/tooltip.component';
import { StatusChipItem } from '@models/discrepancy/status-chip';
import DATA_QA from '@automation/data-qa.json';

@Component({
    selector: 'app-status-filter',
    templateUrl: './status-filter.component.html',
    imports: [ChipComponent, TooltipComponent],
})
export class StatusFilterComponent implements OnChanges {
    @Input() statusChips: StatusChipItem[] = [];
    @Input() selectedStatuses: number[] = [];
    @Output() filterChange = new EventEmitter<number[]>();

    selectedFilterItems: number[] = [];
    readonly dataQa = DATA_QA;

    ngOnChanges(changes: SimpleChanges): void {
        const selectedStatusesChange = changes['selectedStatuses'];
        if (selectedStatusesChange) {
            this.selectedFilterItems = [...selectedStatusesChange.currentValue];
        }
    }

    handleFilterSelect(field: number) {
        this.selectedFilterItems = this.toggleFilterItems(
            this.selectedFilterItems,
            field,
        );
        this.filterChange.emit(this.selectedFilterItems);
    }

    isItemSelected(item: number) {
        return this.selectedFilterItems.includes(item);
    }

    private toggleFilterItems<T>(array: T[], value: T): T[] {
        const index = array.indexOf(value);
        if (index === -1) {
            return [...array, value];
        }

        return array.slice(0, index).concat(array.slice(index + 1));
    }
}
